import border from './border';
import button from './button';
import card from './card';
import checkbox from './checkbox';
import colors from './colors';
import dottedProgress from './dottedProgress';
import font from './font';
import formGroup from './formGroup';
import heading from './heading';
import label from './label';
import palette from './palette';
import radius from './radius';
import select from './select';
import shadow from './shadow';
import { spacing, spacingNumber } from './spacing';
import text from './text';

const corePricelineTheme = {
    border,
    button,
    card,
    checkbox,
    dottedProgress,
    font,
    formGroup,
    heading,
    label,
    palette,
    radius,
    select,
    shadow,
    spacing,
    spacingNumber,
    text,
};

export { colors, corePricelineTheme };
